import { useState } from 'react'

import { Box, useUnsafeEffect } from '@factorialco/deprecated-design-system'

import useLocalStorage from 'modules/core/lib/useLocalStorage'

import { FinancialWorkspaceAvailabilities } from 'modules/finance/components/FinancialWorkspace/hooks/useFinancialWorkspaceAvailabilities'
import { Uploadpayroll } from 'modules/finance/components/FinancialWorkspacePayroll/components/Table/components/UploadPayroll'

import { Banner, localStorageKey } from './LaunchBanner'

interface Props {
  availabilities: FinancialWorkspaceAvailabilities
}

export const Header = ({ availabilities }: Props) => {
  const [date] = useLocalStorage<Date>(`factorial:${localStorageKey}`)
  const [visiblePayrollButton, setVisiblePayrollButton] = useState(
    !!date || availabilities.modules.expenses
  )

  useUnsafeEffect(() => {
    setVisiblePayrollButton(!!date || availabilities.modules.expenses)
  }, [date, availabilities.modules.expenses])

  return (
    <Box gap="s12">
      <Box flexDirection="row" gap="s24" justifyContent="flexEnd">
        <Box flexDirection="column">{visiblePayrollButton && <Uploadpayroll />}</Box>
      </Box>
      <Banner
        onClose={() => setVisiblePayrollButton(true)}
        onRestore={() => setVisiblePayrollButton(false)}
      />
    </Box>
  )
}
